import {HttpErrorResponse} from '@angular/common/http';
import {ErrorResponseCode} from '@emma-labs/shared/typescript';
import {Observable, throwError} from 'rxjs';

export const HUMANIA_LINK = 'https://extranet.humania.ca/home';
export const SHORT_DEBOUNCE_TIME = 500;
export const DEBOUNCE_TIME = 1000;
export const BTN_LOADING_ANIMATION_TIME = 500;
export const FADE_ANIMATION_TIME = 1000;

export const handleHttpError = (error: HttpErrorResponse, errorCallback?: () => void): Observable<never> => {
  const invalidSessionCodes = [ErrorResponseCode.NOT_FOUND, ErrorResponseCode.INVALID_SESSION];

  if (errorCallback && invalidSessionCodes.includes(error.error)) {
    errorCallback();
  }

  return throwError(error.error);
};
